export const GET_CONVERSATION_INFO = 'GET_CONVERSATION_INFO';
export const GET_CONVERSATION_INFO_SUCCESS = 'GET_CONVERSATION_INFO_SUCCESS';
export const GET_CONVERSATION_INFO_FAILED = 'GET_CONVERSATION_INFO_FAILED';
